var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "col content-spacing", attrs: { role: "main" } },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
        },
        [
          _vm.viewData.powerPlant
            ? _c("h1", { staticClass: "h2" }, [
                _vm._v(
                  "\n      Detalhes Usina " +
                    _vm._s(_vm.viewData.powerPlant.name) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.viewData.powerPlant
            ? _c("div", { staticClass: "btn-toolbar mb-2 mb-md-0" }, [
                _c(
                  "div",
                  { staticClass: "btn-group mr-2" },
                  [
                    _c(
                      "BaseButtonComponent",
                      {
                        attrs: {
                          to: `/power-plant/${_vm.viewData.powerPlant.id}/data/new`,
                          variant: "primary-action"
                        }
                      },
                      [_vm._v("Novo detalhe")]
                    )
                  ],
                  1
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.viewData.powerPlant
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("b-breadcrumb", {
                    attrs: {
                      items: [
                        {
                          text: "Lista de Usinas",
                          href: `#/power-plants`
                        },
                        {
                          text: "Usina " + _vm.viewData.powerPlant.name,
                          href: "#",
                          active: true
                        }
                      ]
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.viewData.loading
        ? _c("loading-list")
        : !_vm.viewData.loading && _vm.state.list && _vm.state.list.length > 0
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-between flex-column h-100" },
            [
              _c("v-table", [
                _c("thead", [
                  _c("tr", [
                    _c("td", [_vm._v("Início")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Término")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Potência instalada")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Injeção projetada")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Injeção disponível")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Injeção efetiva")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Créditos")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Receita")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Capex")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Opex")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Resultado")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Custo de energia")]),
                    _vm._v(" "),
                    _c("td")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.state.list, function(item) {
                    return _c("tr", { key: item.id }, [
                      _c("td", [_vm._v(_vm._s(_vm.formatDate(item.start)))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.formatDate(item.end)))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm.formatNumber(item.powerInstalled)))
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.formatNumber(item.projectedInjection))
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.formatNumber(item.availableInjection))
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm.formatNumber(item.injection)))
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm.formatNumber(item.credits)))
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm._f("currency")(item.total)))
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.formatNumber(item.capex)))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.formatNumber(item.opex)))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm._f("currency")(item.result)))
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm._f("currency")(item.energyCost)))
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticStyle: { "text-align": "right" } },
                        [
                          _c(
                            "BaseButtonComponent",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              attrs: {
                                to: `/power-plant/${_vm.viewData.powerPlant.id}/data/edit/${item.id}`,
                                size: "sm",
                                title: "Editar",
                                variant: "primary-action"
                              }
                            },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "pencil-square",
                                  "aria-hidden": "true"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "BaseButtonComponent",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              attrs: {
                                size: "sm",
                                title: "Excluir",
                                variant: "danger"
                              },
                              on: { click: () => _vm.remove(item) }
                            },
                            [
                              _c("b-icon", {
                                attrs: { icon: "trash", "aria-hidden": "true" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("b-pagination-nav", {
                attrs: {
                  "link-gen": _vm.linkGen,
                  "number-of-pages": _vm.state.pageCount,
                  "use-router": ""
                }
              })
            ],
            1
          )
        : !_vm.viewData.loading
        ? _c("empty-list")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }